import WechatAppAuth from "./WechatAppAuth";
import WechatAppRouter from "./WechatAppRouter";
export default class WechatApp {
}
WechatApp.authorize = (config) => {
    return WechatAppAuth.create(config);
};
WechatApp.getPageInfo = () => {
    return WechatAppRouter.getPageInfo();
};
